import Button from '@/components/Button';
import { WapCollapseDownFilled } from '@zeelool/icon';
import { useTranslations } from 'next-intl';

interface ContinuePaymentButtonProps {
  continuePayment: () => void;
}

export default function ContinuePaymentButton({ continuePayment }: ContinuePaymentButtonProps) {
  const t = useTranslations('payment');
  return (
    <div className="flex justify-end mt-[20px]">
      <Button
        className="w-[330px] h-[60px] bg-[#463ae8] rounded-[5px] text-white leading-[60px]"
        variant="contained"
        color="primary"
        onClick={continuePayment}
        sx={{
          fontFamily: 'var(--font-bricolage-bold)',
          fontSize: '18px',
        }}
      >
        {t('ContinueToPayment')}
        <WapCollapseDownFilled className="text-24" />
      </Button>
    </div>
  );
}
